<template>
  <div>

    <div class="divTable" role="table" v-if="items.length">
        <div class="divTable-head" role="rowgroup">
            <div class="divTable-head-row" role="row">
                <div v-for="(tableHeader,index) in tableHeaders" class="divTable-head-row-cell" :id="tableHeader" :key="index" role="columnheader">{{tableHeader}}</div>
            </div>
        </div>
        <div class="divTable-body" role="rowgroup">
            <!-- Product Row -->
            <div
                appear
                name="v-fade"
                v-for="(item, index) in items"
                class="divTable-body-row"
                role="row"
                :key="index"
            >
                <!-- Table-cell (job title)-->
                <div class="divTable-body-row-cell divTable-body-row-cell_product" role="cell">
                    <div class="divTable-body-row-cell-content">
                        <span class="hide_MD m-fontColor_black">{{item.name}}</span>
                        <a :href="item.url" :aria-label="item.name" class="link hide show_MD" target="_blank">{{item.name}}</a>
                    </div>
                </div>

                <!-- Table-cell (job function)-->
                <div class="divTable-body-row-cell divTable-body-row-cell_qty" role="cell">
                    <div class="divTable-body-row-cell-content">
                        {{item.jobFunction}}
                    </div>
                </div>

                <!-- Table-cell (location)-->
                <div class="divTable-body-row-cell divTable-body-row-cell_price" role="cell">
                    <div class="divTable-body-row-cell-content">
                        {{item.location}}
                    </div>
                </div>

                <!-- Table-cell (date posted)-->
                <div class="divTable-body-row-cell divTable-body-row-cell_remove" role="cell">
                    <div class="divTable-body-row-cell-content">
                        {{item.datePosted}}
                    </div>
                </div>
                <a :href="item.url" target="_blank" aria-label="apply now" class="btn btn_tertiary visuallyHide_MD btn_fullWidthMobile">Apply Now</a>
            </div>
        </div>
    </div>
    <div v-else class="section_padding">
        <div class="vr_10 hdg_2 m-text_center" >We’re sorry but your search turned up 0 results. Let’s try again.</div>
        <div class="m-text_center"><button class="btn btn" @click="$emit('reset-search')">Reset</button></div>
    </div>
  </div>
</template>

<script>
export default {
    props: ['items','tableHeaders'],
    methods: {}
};
</script>
